export default {
  props: {
    index: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.showHandle();
    });
  },
  methods: {
    showHandle() {
      if (!this.$refs.hiddenDom || !IntersectionObserver) {
        return;
      }
      // 监听对象
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          // 如果目标元素进入视窗
          if (entry.intersectionRatio > 0) {
            const showElement = entry.target;
            this.buryHandle();
            // 曝光上报完成，取消观察该元素
            observer.unobserve(showElement);
          }
        });
      });
      const obDom = this.$refs.hiddenDom;
      observer.observe(obDom);
    },
    buryHandle() {
      this.$emit('title-show', this.index);
    }
  }
};